import moment from 'moment';
import utils from '@/plugins/TravellerUtils';

const overview = {
    namespaced: true,
    state: {
        systemOverview: []
    },
    mutations: {
        updateSystemOverview(state, overviewList) {
            state.systemOverview = overviewList;
        }
    },
    actions: {
        getSystemOverview(context) {
            return new Promise((resolve, reject) => {
              const currentDate = moment().format("YYYY-MM-DD");
              this._vm.$traveller_http.get('/traveller/restui/system/getSystemOverview', { params: { "currentDate": currentDate } })
                .then(response => {
                    if(utils.checkResponseIsObject(response)) {
                        context.commit('updateSystemOverview', response.data);
                        resolve(response.data);
                    } else {
                        reject("Response is not a object.");
                    }
                }),
                error => {
                    reject(error);
                }
            });
        }
    }
  }
  
  export default overview;